import React from 'react';
import { useSelector } from 'react-redux';
import { ModalHeader } from '../../../../../../CommonComponents/OPL/Modal/ModalHeader';
import { ModalBody } from '../../../../../../CommonComponents/OPL/Modal/ModalBody';
import { ModalFooter } from '../../../../../../CommonComponents/OPL/Modal/ModalFooter';
import { Button } from '../../../../../../CommonComponents/OPL/Button/Button';
import { Modal } from '../../../../../../CommonComponents/OPL/Modal/Modal';
import { useDeleteGoalMutation } from '../../../../api/useDeleteGoalMutation';
import { hasAccessToEditProfileSelector } from '../../../../../../CommonSelectors/CommonAreaSelector';
import { Alert } from '../../../../../../CommonComponents/OPL/Alert/Alert';

interface Props {
  clientId: string;
  goalId: string;
  onClose(): void;
}

export const DeleteDecumulationGoal = ({ clientId, goalId, onClose }: Props) => {
  const canEdit = useSelector(hasAccessToEditProfileSelector);
  const {
    mutateAsync: deleteGoal,
    isLoading: isDeletingGoal,
    error: deleteGoalError,
  } = useDeleteGoalMutation({ clientId });

  const handleDeleteGoal = async () => {
    try {
      await deleteGoal({
        clientId,
        goalId,
      });

      onClose();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Modal
      isOpen
      onRequestClose={onClose}
      shouldCloseOnOverlayClick={false}
      aria={{ labelledby: 'delete-decumulation-goal--modal-header' }}
    >
      <ModalHeader as="h2" id="delete-decumulation-goal--modal-header">
        Are you sure you want to remove this goal?
      </ModalHeader>

      {deleteGoalError && (
        <Alert message={deleteGoalError.message} variant="error" mb="16" mx="24" />
      )}

      <ModalBody>This action cannot be undone.</ModalBody>

      <ModalFooter>
        <Button variant="subtleInactive" onClick={onClose}>
          {canEdit ? 'Cancel' : 'Close'}
        </Button>

        {canEdit && (
          <Button isLoading={isDeletingGoal} onClick={handleDeleteGoal} variant="error" ml="8">
            Remove Goal
          </Button>
        )}
      </ModalFooter>
    </Modal>
  );
};
